// @ts-nocheck
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useToast } from 'hooks';
import { API_URL, ACCESS_DOCUMENTS_API, PDF_DOWNLOAD_API } from './apiConfig';
import useStatusConfirm from './useStatusConfirm';

const useClientAccessDaywork = () => {
  const { keyParams, emailParam } = useStatusConfirm();
  const [pdfDataLoading, setPdfDataLoading] = useState(true);
  const [pdfData, setPdfData] = useState(null);
  const [dayworkDocketId, setDayworkDocketId] = useState(null);
  const [downloadLoadingPdf, setDownloadLoadingPdf] = useState(false);
  const email = encodeURIComponent(emailParam);
  const toast = useToast();
  const [pdf, setPdf] = useState('');
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const fetchLinkAccessDocument = async () => {
      try {
        if (keyParams && emailParam) {
          const response = await axios.get(
            `${API_URL}${ACCESS_DOCUMENTS_API}?key=${keyParams}&email=${email}`,
          );
          setPdfData(response.data.data);
          const dayworkId = response.data.data.daywork_docket_id;
          setDayworkDocketId(dayworkId);
        }
        setPdfDataLoading(false);
      } catch (error) {
        console.error('Error fetching link access document:', error);
        setPdfDataLoading(false);
      }
    };

    if (keyParams && emailParam) {
      fetchLinkAccessDocument();
    }
  }, [keyParams, emailParam]);

  // DOWNLOAD PDF

  // DOWNLOAD PDF
  const onDownloadPdf = async () => {
    try {
      setDownloadLoadingPdf(true);
      const response = await axios.get(
        `${API_URL}${PDF_DOWNLOAD_API}?key=${keyParams}`,
      );

      // const a = document.createElement('a');
      // a.href = response?.data?.data?.url;
      // a.target = '_blank';
      // a.download = 'DayworkDocket';
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);
      setOpenModal(true);
      setPdf(response.data?.data?.url);
      setDownloadLoadingPdf(false);

    } catch (error) {
      console.error('Error downloading PDF:', error);
      setDownloadLoadingPdf(false);
    }
  };
  return {
    pdfDataLoading,
    pdfData,
    dayworkDocketId,
    downloadLoadingPdf,
    onDownloadPdf,
    pdf,
    openModal,
    setOpenModal,
  };
};

export default useClientAccessDaywork;
